import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import styles from './navigation-account-side.css'

import MyListIcon from './my-list-icon'
import MyRentalsIcon from './my-rentals-icon'
import AvatarSection from './avatar-section'
import { STATIC_SCREENS } from '../../../constants'
import { E2E_SELECTORS } from '../../../e2e-selectors'

const NavigationAccountSide = ({
  userName,
  avatarUri,
  onSwitchProfileClick,
  isAccountNavOpen,
  onToggleAccountNav,
  onSideNavLinkClick,
  myRentalsTotalItems,
  isKid
}) => {
  return (
    <div className={styles.navAccountSideWrapper} id="navigation-account-side">
      <div className={styles.navAccountSide}>
        <AvatarSection
          userName={userName}
          avatarUri={avatarUri}
          isKid={isKid}
          isAccountNavOpen={isAccountNavOpen}
          onToggleAccountNav={onToggleAccountNav}
          onSwitchProfileClick={onSwitchProfileClick}
        />
        {
          // Show My list and My rentals when account menu is open or user is a kid profile
          (isAccountNavOpen || isKid) && (
            <div className={styles.navAccountSection}>
              <ul className={styles.accountLinks}>
                <li>
                  <NavLink
                    exact
                    to={STATIC_SCREENS.MY_LISTS.screenId}
                    className={styles.accountLink}
                    onClick={onSideNavLinkClick}
                  >
                    <MyListIcon isKid={isKid} />
                    <span
                      className={styles.accountLinkText}
                      data-lbx-e2e={isKid ? E2E_SELECTORS.MY_LIST_KIDS_NAVSIDE : undefined}
                    >
                      My lists
                    </span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    exact
                    to={STATIC_SCREENS.MY_RENTALS.screenId}
                    className={styles.accountLink}
                    onClick={onSideNavLinkClick}
                  >
                    <MyRentalsIcon isKid={isKid} />
                    <span
                      className={styles.accountLinkText}
                      data-lbx-e2e={isKid ? E2E_SELECTORS.MY_RENTALS_KIDS_NAVSIDE : undefined}
                    >
                      My rentals
                    </span>
                    { myRentalsTotalItems > 0 && <span>{`(${myRentalsTotalItems})`}</span> }
                  </NavLink>
                </li>
              </ul>
            </div>
          )
        }
      </div>
    </div>
  )
}

NavigationAccountSide.propTypes = {
  isKid: PropTypes.bool.isRequired,
  isAccountNavOpen: PropTypes.bool.isRequired,
  onToggleAccountNav: PropTypes.func.isRequired,
  onSideNavLinkClick: PropTypes.func.isRequired,
  userName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]).isRequired,
  avatarUri: PropTypes.string.isRequired,
  onSwitchProfileClick: PropTypes.func.isRequired,
  myRentalsTotalItems: PropTypes.number.isRequired
}

export default NavigationAccountSide
